import Text from 'components/3catinfo/Text';
import styles from './bustiadenuncia.module.scss';
import Icona from '../ui/Icona/Icona';
import Enllac from '../Enllac/Enllac';

export default function BustiaDenuncia() {
    return (
        <div className={styles.bustiaDenuncia}>
            <div className={styles.colLeft}>
                <div className={styles.text}>
                    <Text
                        className={styles.titol}
                        tag='h4'
                        text="Tens alguna informació que creus que hauríem d'investigar?"
                    ></Text>
                    <Text
                        className={styles.contingut}
                        tag='p'
                        text={`Vols denunciar una situació d'abús, agressió o assetjament? Creus que `+
                        `hauríem de seguir alguna pista sobre un possible cas de corrupció? O tens algun `+
                        `altre tema d'interès general que creguis que ens n'hem de fer ressò?`}
                    ></Text>
                </div>
                <div className={styles.boto}>
                    <Enllac estil='boto' href='mailto:bustiadenuncia@3cat.cat'>
                        Explica&#39;ns-ho a&nbsp;<u>bustiadenuncia@3cat.cat</u>
                    </Enllac>
                </div>
            </div>
            <div className={styles.colRight}>
                <div className={styles.llistaWrapper}>
                    <div className={styles.llistaTitol}>
                        <Icona icona='security-safe' isBlanc={true} className={styles.icona} mida={22} />
                        <span>Senzill, segur i anònim</span>
                    </div>
                    <ol className={styles.llista}>
                        <li>La informació rebuda serà tractada de forma confidencial i se&#39;n comprovarà la seva veracitat.</li>
                        <li>Si és d&#39;interès periodístic, la farem pública. </li>
                        <li>En tot moment, respectant l&#39;anonimat de les persones denunciants, si és la seva voluntat.</li>
                    </ol>
                </div>
            </div>
        </div>
    );
}
